import { Link, useSearchParams } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { ResetPasswordForm } from '../../components/auth';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const isSetPassword = searchParams.get('intent') === 'set-password';
  const invitedBy = searchParams.get('invitedBy')?.trim();
  const showInviteMessage = isSetPassword && invitedBy;

  return (
    <div className="min-h-screen flex items-center justify-center bg-linen px-4 py-8">
      <Card className="w-full max-w-md p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-8">
            <img src="/logo.png" alt="CareCal" className="h-10 w-auto" />
          </div>
          <h1 className="font-display text-3xl font-bold text-blueviolet mb-2">
            {isSetPassword ? 'Set your password' : 'Reset your password'}
          </h1>
          {showInviteMessage ? (
            <p className="font-body text-sm leading-6 text-night-500">
              <strong className="font-semibold text-night-900">{invitedBy}</strong> has invited
              you to join their CareCal team.
            </p>
          ) : null}
        </div>

        <ResetPasswordForm isSetPassword={isSetPassword} />

        {!isSetPassword && (
          <div className="mt-6 flex justify-center gap-4 font-body text-sm">
            <Link
              to="/auth/login"
              className="font-medium text-blueviolet hover:text-blueviolet-light text-center underline"
            >
              Log in
            </Link>
            {'    '}
            <Link
              to="/auth/register"
              className="font-medium text-blueviolet hover:text-blueviolet-light text-center underline"
            >
              Create New Account
            </Link>
          </div>
        )}
      </Card>
    </div>
  );
}
